import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the PositionDiffClassPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'positionDiffClass',
})
export class PositionDiffClassPipe implements PipeTransform {
  transform(change) {
    if (change > 0) {
      return 'diff-positive';
    } else if (change < 0) {
      return 'diff-negative';
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/shared/pipes/position-diff-class/position-diff-class.ts